import React from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { PageTitle } from "../../components/Common/PageTitle";
import { MassPostForm } from "../../components/MassPostPage/MassPostForm";
import { useMeWithOrganizationImpersonation } from "../../hooks/organizationImpersonation";
import { useValidateOrganization } from "../../hooks/validateUserOrganization";

import "./styles.scss";

type IMassPostPageProps = RouteComponentProps<any>;

const MassPostPage: React.FunctionComponent<IMassPostPageProps> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`massPostPage.${key}`);

  const me = useMeWithOrganizationImpersonation();
  const matchOrganizationId = props.match.params.organizationId;

  useValidateOrganization({
    matchOrganizationId,
    redirectUrlFormat: (orgId) => `/massPost/organization/${orgId}`,
  });

  return (
    <div className="right-content mass-post-page">
      <div className="top-title-bar">
        <PageTitle text={t("mass_post_page")} />
      </div>
      {me && (
        <MassPostForm organizationId={matchOrganizationId} userId={me.id} />
      )}
    </div>
  );
};

export default withRouter(MassPostPage);
